import { useEffect, useRef } from 'react';

type InfiniteScrollProps = {
  loadMore: () => void;
  isLoading: boolean;
  elementId: string;
};

const InfiniteScroll = ({ loadMore, isLoading, elementId }: InfiniteScrollProps) => {
  const observer = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '40px',
      threshold: 1.0
    };

    const loadMoreElement = document.querySelector(`#${elementId}`);

    if (loadMoreElement && !observer.current) {
      observer.current = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && !isLoading) {
          loadMore();
        }
      }, options);

      observer.current.observe(loadMoreElement);
    }

    return () => {
      if (observer.current && loadMoreElement) {
        observer.current.unobserve(loadMoreElement);
        observer.current.disconnect();
        observer.current = null;
      }
    };
  }, [loadMore, isLoading, elementId]);

  return null;
};

export default InfiniteScroll;
